module.exports = __webpack_public_path__ + "static/img/broken-light-error.4fd3f1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broken-light-error.svg
// module id = QmHV
// module chunks = 3